'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var styled = require('styled-components');
var PropTypes = require('prop-types');
var index = require('../core/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Ele = styled__default['default'].div.attrs(function () {
  return {
    _component: 'alert'
  };
})(_templateObject(), index.styleEngine);

var Alert = function Alert(props) {
  return /*#__PURE__*/React__default['default'].createElement(Ele, props);
};

Alert.defaultProps = {
  variant: 'primary'
};
Alert.propTypes = {
  /**
   * Check theme sheet for available variants
   */
  variant: PropTypes__default['default'].string,

  /**
   * Specifies what to be rendered inside the component
   */
  children: PropTypes__default['default'].node
};

exports.default = Alert;
